<template>
  <div>
    <data-table
      ref="tabelaLicencas"
      api-route="/licencas/"
      item-key="hash"
      :columns="columns"
      :filters="filters"
      :actions="actions"
      sort-by="data_ativacao"
      :sort-desc="true"
    />
    <FloatBtn text="Cadastrar Licença" @click="abrirDialogCadastro" />
    <CadastroLicencaDialog v-model="dialogCadastro" @licenca-cadastrada="recarregarTabela" />
  </div>
</template>

<script>
import DataTable from './comum/DataTable.vue';
import FloatBtn from './FloatBtn.vue';
import CadastroLicencaDialog from './CadastroLicencaDialog.vue';

export default {
  components: {
    DataTable,
    FloatBtn,
    CadastroLicencaDialog
  },
  data() {
    return {
      dialogCadastro: false,
      columns: [
        { key: 'codcliente', title: 'Cód. Cliente' },
        { key: 'codplano', title: 'Cód. Plano' },
        { key: 'data_ativacao', title: 'Data Ativação', format: (date) => new Date(date).toLocaleDateString('pt-BR') },
        { key: 'data_expiracao', title: 'Data Expiração', format: (date) => new Date(date).toLocaleDateString('pt-BR') },
        { 
          key: 'ativa', 
          title: 'Status', 
          type: 'chip', 
          format: (val) => (val ? 'Ativa' : 'Inativa'),
          color: (item) => (item.ativa ? 'success' : 'error')
        },
      ],
      filters: [
        { model: 'codcliente', label: 'Filtrar por Cód. Cliente', type: 'number', icon: 'mdi-magnify' },
        { model: 'codplano', label: 'Filtrar por Cód. Plano', type: 'number', icon: 'mdi-package-variant' },
        { 
          model: 'ativa', 
          label: 'Filtrar por Status', 
          type: 'select', 
          icon: 'mdi-list-status',
          items: [{title: 'Ativas', value: true}, {title: 'Inativas', value: false}]
        }
      ],
      actions: [
        { 
          icon: 'mdi-magnify', 
          tooltip: 'Visualizar', 
          handler: (item) => {
            this.$router.push({ name: 'licenca-detalhe', params: { hash: item.codcliente } });
          }
        }
      ]
    };
  },
  methods: {
    abrirDialogCadastro() {
      this.dialogCadastro = true;
    },
    recarregarTabela() {
      this.$refs.tabelaLicencas.recarregar();
    }
  },
};
</script>
